import { BaseService, type ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { Certificate } from "@kiddocare-platform/portal-common/certifications";

export class CertificationsConfigurationService extends BaseService {

  public async GetByPediatrician(idAccountPediatrician: bigint): Promise<ResponseMessage<Array<Certificate>>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/configuration/certificates/getByPediatrician/${idAccountPediatrician}`);
      return response.data;
    }
    catch (error: any) {
      this.log.error("GetByPediatrician", error.stack, JSON.stringify(error));
      throw error.response?.data ? error.response.data : error;
    }
  }

  public async GetCertificateById(idCertificate: bigint): Promise<ResponseMessage<Certificate>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/configuration/certificates/getCertificateById/${idCertificate}`);
      return response.data;
    }
    catch (error: any) {
      this.log.error("GetCertificateById", error.stack, JSON.stringify(error));
      throw error.response.data ? error.response.data : error;
    }
  }

}